import HistoryMap20cent from "../components/HistoryMap20cent";

function HistoryMapNew () {

    return (
        <HistoryMap20cent />
    )
}

export default HistoryMapNew;